import React from "react";
import { useTranslation } from "react-i18next";
const TorExitNodeAdapterSummary = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement("i", null, t("tor_exit_node_adapter_summary.no_configuration"));
};
export default TorExitNodeAdapterSummary;
